import React from 'react'
import { Box, Text } from '@chakra-ui/core'
import GridContainer from 'components/GridContainer'
import GridItem from 'components/GridItem'
import RichText from 'components/RichText'
import Date from 'components/Date'
import { Alert } from 'types'

const GlobalAlerts = ({ alerts }: Props) => {
  if (!alerts.length) return <></>

  return (
    <Box backgroundColor="red.50" py={[6, 10]}>
      <GridContainer padding rowGap={4} alignItems="flex-start">
        {alerts.map((alert) => (
          <GridItem
            key={alert.uid}
            colSpan={[12, 6]}
            p={4}
            backgroundColor="white"
          >
            <Text fontWeight="bold" mb={2} fontSize={['sm', 'md']}>
              {alert.heading}
            </Text>
            <RichText>{alert.text}</RichText>
            <Text fontWeight="bold" fontSize="xs" color="red.900" mt={2}>
              Oppdatert <Date>{alert.updatedAt}</Date>
            </Text>
          </GridItem>
        ))}
      </GridContainer>
    </Box>
  )
}

type Props = {
  alerts: [Alert]
}

export default GlobalAlerts
